import graphql__2407a2887376034cdb0d from "./__generated__/ProfileSettingsForm_user.graphql.js";
import graphql__9aa5f208b22c002caceb from "./__generated__/ProfileSettingsForm_notificationCycles.graphql.js";import { Component } from "react";
import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import { defineMessages, injectIntl } from "react-intl";

import NotificationSettingsForm from "../Notifications/NotificationSettingsForm";
import withFormStore from "../Form/withFormStore";
import withAlert from "../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";
import Button from "../Buttons/Button";

import { updateNotificationSettings } from "../../mutations/UpdateNotificationSettingsMutation";

class ProfileSettingsForm extends Component {
  state = {};

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdateResponse = this.onUpdateResponse.bind(this);
  }

  get labels() {
    const { formatMessage } = this.props.intl;

    return {
      update: formatMessage(intlMessages.update),
      success: formatMessage(intlMessages.success)
    };
  }

  get isSubmitting() {
    return this.state.status === "submitting";
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.props.validateForm()) {
      this.setState({ status: "submitting" });

      updateNotificationSettings(this.props.formState, this.onUpdateResponse);
    }
  }

  onUpdateResponse(response) {
    this.setState({ status: "responseReceived" });

    if (response.updateNotificationSettings.success) {
      this.props.showAlert({
        message: this.labels.success,
        type: ALERT_TYPE_SUCCESS
      });
    } else {
      this.props.showAlert({
        message: response.updateNotificationSettings.notice,
        type: ALERT_TYPE_ERROR
      });

      this.props.pushErrors(response.updateNotificationSettings.errors);
    }
  }

  render() {
    const { user, notificationCycles } = this.props;
    const { update } = this.labels;
    const { onSubmit, isSubmitting } = this;

    return (
      <form className={this.formClassName} onSubmit={this.onSubmit}>
        <NotificationSettingsForm
          recipient={user}
          notificationCycles={notificationCycles}
        />

        <Button
          type="submit"
          className="btn btn-primary btn-block-md"
          onClick={onSubmit}
          label={update}
          disabled={isSubmitting}
          data-loading={isSubmitting}
          iconClassName="icon-arrow-right"
          iconPosition="after"
        />
      </form>
    );
  }
}

export default withFormStore(
  withAlert(
    injectIntl(
      createFragmentContainer(ProfileSettingsForm, {
        user: graphql__2407a2887376034cdb0d,
        notificationCycles: graphql__9aa5f208b22c002caceb
      })
    )
  )
);

const intlMessages = defineMessages({
  update: {
    id: "profile.settings.update",
    defaultMessage: "Mettre à jour"
  },
  success: {
    id: "profile.settings.success",
    defaultMessage: "Les paramètres de votre compte ont bien été mis à jour !"
  }
});
